import styled from '@emotion/styled';

export const CompetitionName = styled('div', { label: 'CompetitionName' })`
    padding: 0 0 2px 6px;
`;
